// look up a single prompt by id (or by a pasted prompt url) and show it on
// its own in the prompts list, so an admin handling a takedown request can go
// straight to the prompt instead of paging through the filtered list
// used by adminpage/AdminPromptsToolbar.js
import { doc, getDoc } from 'firebase/firestore';
import { firestore } from '../firebase';
import {
  asyncActionStart,
  asyncActionFinish,
  asyncActionError
} from './asyncActions';
import { openSnackbar } from './snackbarActions';
import { filterPrompts } from './filterPrompts';
import { promptIdFromInput } from '../utils/convertToFromUri';
import { GET_PROMPTS } from './types';

export const findPrompt = input => async (dispatch, getState) => {
  const promptID = promptIdFromInput(input);
  if (!promptID) return;
  dispatch(asyncActionStart());
  try {
    const promptSnapshot = await getDoc(doc(firestore, 'prompts', promptID));
    if (!promptSnapshot.exists()) {
      dispatch(asyncActionFinish());
      dispatch(
        openSnackbar('ErrorSnackbar', {
          message: `No prompt found with id ${promptID}`
        })
      );
      return;
    }

    const prompt = { ...promptSnapshot.data(), id: promptSnapshot.id };
    dispatch({ type: GET_PROMPTS, payload: { [promptID]: prompt } });

    // we are showing a single prompt, not a page of results, so clear the
    // pagination cursor and mark it as the last page to hide the Next button
    const { filter } = getState();
    dispatch(
      filterPrompts({
        ...filter,
        lastPrompt: null,
        previousOrNext: null,
        pageNumber: 1,
        lastPage: true
      })
    );
    dispatch(asyncActionFinish());
  } catch (error) {
    const { code, message } = error;
    console.error(error);
    dispatch(asyncActionError({ code, message }));
    dispatch(openSnackbar('ErrorSnackbar', { message }));
  }
};
